import { Button } from '@e2n/ui';
import { useTranslation } from 'react-i18next';
import { Vertrag } from '@/domain/vertraege/shared/types/vertrag';
import { WithFeatureFlags } from '@/features/featureFlags/WithFeatureFlags';
import { VertragKuendigen } from '@/domain/vertraege/features/VertragKuendigen/VertragKuendigen';
import { Link } from 'react-router-dom';

export function Footer({ vertrag }: { vertrag: Vertrag }) {
  const { t } = useTranslation();
  return (
    <div className="w-full flex gap-2">
      <WithFeatureFlags name="vertraege-2" Fallback={<></>}>
        {vertrag.hasAktuellesVertragsmodell() && (
          <Button>
            {t('domain.vertraege.upgradeInfo.kontingentAnpassen')}
          </Button>
        )}
      </WithFeatureFlags>
      <WithFeatureFlags
        name="vertraege-2"
        Fallback={
          <Link
            to={'https://e2n.de/backoffice/#k%C3%BCndigung'}
            target="_blank">
            <Button variant="outline-secondary">
              {t('domain.vertraege.kuendigung.button')}
            </Button>
          </Link>
        }>
        <VertragKuendigen vertrag={vertrag} />
      </WithFeatureFlags>
    </div>
  );
}
